import React from 'react';
import { Accordion, Badge } from '@mantine/core';
import { Code } from 'lucide-react';
import { humanizeText } from 'utils/utility';
import { IBookingExternalAPILog } from 'libs/data-access/types';
import { LogItem } from './LogItem';

interface IApiNameAccordionProps {
    groupedByApiName: { [apiName: string]: IBookingExternalAPILog[] };
    isDownloading: boolean;
    onDownload: (mediaId: number, fileName: string) => void;
}

export const ApiNameAccordion: React.FC<IApiNameAccordionProps> = ({
    groupedByApiName,
    isDownloading,
    onDownload
}) => {
    return (
        <Accordion
            variant="contained"
            defaultValue={Object.keys(groupedByApiName)[0]}
            chevronPosition="left"
        >
            {Object.keys(groupedByApiName).map((apiName) => (
                <Accordion.Item
                    key={apiName}
                    value={apiName}
                >
                    <Accordion.Control>
                        <div className="flex items-center justify-between pr-4">
                            <div className="flex items-center gap-3">
                                <div className="p-2 bg-indigo-50 rounded-lg">
                                    <Code size={18} className="text-indigo-600" />
                                </div>
                                <div>
                                    <span className="font-semibold text-gray-800 text-base">
                                        {humanizeText(apiName)}
                                    </span>
                                    <div className="text-xs text-gray-500 mt-0.5">
                                        {groupedByApiName[apiName].length}{' '}
                                        {groupedByApiName[apiName].length === 1 ? 'API call' : 'API calls'}
                                    </div>
                                </div>
                            </div>
                            <Badge
                                variant="filled"
                                color="blue"
                                size="md"
                            >
                                {groupedByApiName[apiName].length}
                            </Badge>
                        </div>
                    </Accordion.Control>
                    <Accordion.Panel>
                        <div className="space-y-3">
                            {groupedByApiName[apiName].map((log: IBookingExternalAPILog) => (
                                <LogItem
                                    key={log.id}
                                    log={log}
                                    isDownloading={isDownloading}
                                    onDownload={onDownload}
                                />
                            ))}
                        </div>
                    </Accordion.Panel>
                </Accordion.Item>
            ))}
        </Accordion>
    );
};
